/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { useCallback } from 'react';
import { saveTeamPermissions } from 'asset-actions-lib/api/manageAccess';
export default function useSaveTeamPermissions({
  objectType,
  objectId
}) {
  const saveTeamPermissionsCallback = useCallback(selectedTeamIds => saveTeamPermissions({
    objectType,
    objectId,
    teamIds: selectedTeamIds
  }), [objectId, objectType]);
  const value = {
    saveTeamPermissions: saveTeamPermissionsCallback
  };
  return value;
}